<template>
  <v-col class="features-content">
    <v-row class="mb-4">
      <v-col>
        <h1 class="headline font-weight-bold mb-2">
          Features Overview
        </h1>
        <p class="body-1 coolgray--text">
          Browse major capabilities in iAdOps. Use feature pages for
          implementation details, workflows, and validation notes.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-for="feature in featureCards"
        :key="feature.id"
        cols="12"
        sm="6"
      >
        <v-card
          outlined
          class="pa-4 fill-height"
        >
          <div class="subtitle-1 font-weight-bold mb-2 d-flex align-center">
            <font-awesome-icon
              :icon="feature.icon"
              class="mr-2"
              size="sm"
            />
            {{ feature.title }}
          </div>

          <p class="body-2 mb-4">
            {{ feature.description }}
          </p>

          <v-btn
            outlined
            class="text-none"
            :to="feature.path"
          >
            Open Guide
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'FeaturesContent',
  computed: {
    featureCards() {
      return [
        {
          id: 'delivery',
          title: 'Delivery Reports',
          description: 'Pacing and discrepancy workflows, key metrics, and usage patterns.',
          icon: ['fas', 'chart-line'],
          path: '/docs/delivery',
        },
        {
          id: 'search',
          title: 'Search and Selected Context',
          description: 'How global search updates context, navigation behavior, and keyboard support.',
          icon: ['fas', 'magnifying-glass'],
          path: '/docs/search',
        },
        {
          id: 'feedback',
          title: 'Feedback',
          description: 'In-app feedback submission, server validation, and persistence behavior.',
          icon: ['fas', 'message'],
          path: '/docs/feedback',
        },
        {
          id: 'filters',
          title: 'Filters',
          description: 'Filtering workflows, common filter patterns, and productivity tips.',
          icon: ['fas', 'filter'],
          path: '/docs/filters',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.features-content {
  max-width: 900px;
}
</style>
